import {
	ClientSubType,
	EmailRecipientType,
} from '@models/global-email-templates';
import { JurisdictionDepartments } from '@models/jurisdictions';
import { matterFileTypeLabel } from '@models/matter';

export const fileTypeOptions = [
	{
		text: 'All',
		id: 'all',
	},
].concat(
	Array.from(matterFileTypeLabel.entries()).map(([key, value]) => ({
		text: value,
		id: key,
	})),
);

export const emailRecipientTypeOptions = [
	{
		text: 'All',
		id: EmailRecipientType.ALL,
	},
	{
		text: 'Client',
		id: EmailRecipientType.CLIENT,
		subTypes: Object.values(ClientSubType).map((subType) => ({
			text: subType.charAt(0).toUpperCase() + subType.slice(1),
			id: subType,
		})),
	},
	{
		text: 'Package email',
		id: EmailRecipientType.PACKAGE_EMAIL,
		subTypes: Object.values(ClientSubType).map((subType) => ({
			text: subType.charAt(0).toUpperCase() + subType.slice(1),
			id: subType,
		})),
	},
	{
		text: 'Jurisdiction',
		id: EmailRecipientType.JURISDICTION,
		subTypes: Object.values(JurisdictionDepartments).map((subType) => ({
			text: subType.charAt(0).toUpperCase() + subType.slice(1),
			id: subType,
		})),
	},
] as const;
